function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { anatomy } from '@chakra-ui/theme-tools';
import { mode } from '@chakra-ui/theme-tools';
export var parts = anatomy('table').parts('table', 'thead', 'tbody', 'tr', 'th', 'td', 'tdBefore', 'tdPivoted', 'tfoot', 'caption');
export var tdBeforeStyles = props => {
  var {
    breakpoint
  } = props;
  return {
    /* Hide on Mobile */
    display: {
      base: 'block',
      [breakpoint]: 'none'
    },

    /* Now act like a table header */
    position: {
      base: 'absolute',
      [breakpoint]: 'static'
    },

    /* Top/left values mimic padding */
    left: '1rem',
    width: {
      base: 'calc(50% - 20px)',
      [breakpoint]: 'inherit'
    },
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    textAlign: 'left',
    fontWeight: 'bold'
  };
};
export var tdPivotedStyles = props => {
  var {
    breakpoint
  } = props;
  return {
    border: 'none',
    textAlign: 'left',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    display: {
      base: 'block',
      [breakpoint]: 'table-cell'
    },

    /* Behave like a 'row' */
    position: {
      base: 'relative',
      [breakpoint]: 'static'
    },
    paddingLeft: {
      base: 'calc(50% - 10px)',
      [breakpoint]: 6
    }
  };
};
var numericStyles = {
  '&[data-is-numeric=true]': {
    textAlign: 'end'
  }
};

var variantSimple = props => {
  var {
    colorScheme: c
  } = props;
  return {
    th: _extends({
      color: mode('black', 'gray.400')(props),
      borderBottom: '1px',
      borderColor: mode(c + ".400", c + ".700")(props)
    }, numericStyles),
    td: _extends({
      borderBottom: '1px',
      borderColor: mode(c + ".400", c + ".700")(props)
    }, numericStyles),
    caption: {
      color: mode('gray.600', 'gray.100')(props)
    },
    tfoot: {
      tr: {
        '&:last-of-type': {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
};

var variantStripe = props => {
  var {
    colorScheme: c
  } = props;
  return {
    th: _extends({
      color: mode('black', 'gray.400')(props),
      borderBottom: '1px',
      borderColor: mode(c + ".100", c + ".700")(props)
    }, numericStyles),
    td: _extends({
      borderBottom: '1px',
      borderColor: mode(c + ".100", c + ".700")(props)
    }, numericStyles),
    caption: {
      color: mode('gray.600', 'gray.100')(props)
    },
    tbody: {
      tr: {
        '&:nth-of-type(odd)': {
          'th, td': {
            borderBottomWidth: '1px',
            borderColor: mode(c + ".100", c + ".700")(props)
          },
          td: {
            background: mode(c + ".100", c + ".700")(props)
          }
        }
      }
    },
    tfoot: {
      tr: {
        '&:last-of-type': {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
};

var baseStyle = props => {
  var {
    breakpoint
  } = props;
  return {
    table: {
      fontVariantNumeric: 'lining-nums tabular-nums',
      borderCollapse: 'collapse',
      width: 'full'
    },

    /*
    Force table elements to not behave like tables anymore
    Hide table headers (but not display: none; for accessibility)
    */
    thead: {
      display: {
        base: 'block',
        [breakpoint]: 'table-header-group'
      },
      tr: {
        position: {
          base: 'absolute',
          [breakpoint]: 'static'
        },
        top: {
          base: '-9999px',
          [breakpoint]: 'unset'
        },
        left: {
          base: '-9999px',
          [breakpoint]: 'unset'
        }
      }
    },
    tbody: {
      display: {
        base: 'block',
        [breakpoint]: 'table-row-group'
      },
      tr: {
        padding: {
          base: '0.25em',
          [breakpoint]: '0'
        },
        borderBottom: '1px',
        borderColor: 'gray.300'
      }
    },
    tr: {
      display: {
        base: 'block',
        [breakpoint]: 'table-row'
      }
    },
    th: {
      fontFamily: 'heading',
      fontWeight: 'bold',
      letterSpacing: 'wider',
      textAlign: 'start',
      textTransform: 'none',
      display: {
        base: 'block',
        [breakpoint]: 'table-cell'
      }
    },
    td: {
      textAlign: 'start',
      display: {
        base: 'block',
        [breakpoint]: 'table-cell'
      }
    },
    caption: {
      mt: 4,
      fontFamily: 'heading',
      textAlign: 'center',
      fontWeight: 'medium'
    },
    tdPivoted: tdPivotedStyles(props),
    tdBefore: tdBeforeStyles(props)
  };
};

var sizes = {
  sm: {
    th: {
      px: '4',
      py: '1',
      lineHeight: '4',
      fontSize: 'xs'
    },
    td: {
      px: '4',
      py: '2',
      fontSize: 'sm',
      lineHeight: '4'
    },
    caption: {
      px: '4',
      py: '2',
      fontSize: 'xs'
    }
  },
  md: {
    th: {
      px: '6',
      py: '3',
      lineHeight: '4',
      fontSize: 'xs'
    },
    td: {
      px: '6',
      py: '4',
      lineHeight: '5'
    },
    caption: {
      px: '6',
      py: '2',
      fontSize: 'sm'
    }
  },
  lg: {
    th: {
      px: '8',
      py: '4',
      lineHeight: '5',
      fontSize: 'sm'
    },
    td: {
      px: '8',
      py: '5',
      lineHeight: '6'
    },
    caption: {
      px: '6',
      py: '2',
      fontSize: 'md'
    }
  }
};
var variants = {
  simple: variantSimple,
  striped: variantStripe,
  unstyled: {}
};
var defaultProps = {
  breakpoint: 'md',
  colorScheme: 'gray',
  variant: 'simple',
  size: 'md'
};
export default {
  parts: parts.keys,
  variants,
  sizes,
  baseStyle,
  defaultProps
};
//# sourceMappingURL=ResponsiveTable.js.map